/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boiling point at pressure`)
};

const es_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punto de ebullición a presión`)
};

const de_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siedepunkt bei Druck`)
};

const nl_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kookpunt bij druk`)
};

const fr_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Point d'ébullition à pression donnée`)
};

const it_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punto di ebollizione alla pressione`)
};

const pt_br2_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponto de ebulição por pressão`)
};

const pt_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponto de ebulição à pressão`)
};

const ja_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧力から沸点を求める`)
};

const zh_bp_mode_bp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指定压力下的沸点`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_mode_bp = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_mode_bp(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_mode_bp", locale)
	if (locale === "en") return en_bp_mode_bp(inputs)
	if (locale === "es") return es_bp_mode_bp(inputs)
	if (locale === "de") return de_bp_mode_bp(inputs)
	if (locale === "nl") return nl_bp_mode_bp(inputs)
	if (locale === "fr") return fr_bp_mode_bp(inputs)
	if (locale === "it") return it_bp_mode_bp(inputs)
	if (locale === "pt-BR") return pt_br2_bp_mode_bp(inputs)
	if (locale === "pt") return pt_bp_mode_bp(inputs)
	if (locale === "ja") return ja_bp_mode_bp(inputs)
	return zh_bp_mode_bp(inputs)
};